import Confetti from "react-confetti";

import { useTranslate } from "@similarweb/i18n-provider";
import { CheckCircle } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { NO_TOUCH_PURCHASE_TRANSLATIONS } from "app/components/no-touch-purchase-modal/translations";

interface INoTouchPurchaseSuccessProps {
    onConfirmClick: () => void;
}

export const NoTouchPurchaseSuccess = ({ onConfirmClick }: INoTouchPurchaseSuccessProps) => {
    const { translate } = useTranslate();

    return (
        <Flex
            flexDirection="column"
            gap="36px"
            height="100%"
            padding="48px 95px"
            alignItems="center"
        >
            <Confetti
                width={document.documentElement.clientWidth}
                height={document.documentElement.clientHeight}
                numberOfPieces={200}
                recycle={false}
            />

            <CheckCircle
                size="xxl"
                color={colorsPalettes.solutions.INVESTORS}
            />

            <Flex
                flexDirection="column"
                gap="24px"
            >
                <Text
                    fontVariant="h4"
                    textAlign="center"
                >
                    {translate(NO_TOUCH_PURCHASE_TRANSLATIONS.success.purchaseSuccessful)}
                </Text>

                <Flex
                    flexDirection="column"
                    gap="12px"
                >
                    <Text
                        fontVariant="body1"
                        textAlign="center"
                    >
                        {translate(NO_TOUCH_PURCHASE_TRANSLATIONS.success.purchaseSuccessfulText)}
                    </Text>
                </Flex>
            </Flex>

            <Button
                type="primary"
                onClick={onConfirmClick}
            >
                {translate(NO_TOUCH_PURCHASE_TRANSLATIONS.success.done)}
            </Button>
        </Flex>
    );
};
